<template>
  <div>
    <b-col cols="12" class="mt-2 mb-2">
      <img src="~@/core/Images/ja-logo-login.svg" class="center-img" alt="JA-LOGIN">
    </b-col>
    <b-row class="legal-message">
      <b-col cols="12" class="mt-3 text-center">
      <span class="legal-text-title">
        <a class="text-purple" href="https://jausa.ja.org/about/website-terms-and-conditions" target="_blank">{{ $t("legal_message_terms_conditions") }}</a>
         | <a class="text-purple" href="https://jausa.ja.org/about/privacy-policy" target="_blank">{{ $t("legal_message_privacy_policy") }}</a>
      </span>
      </b-col>
      <b-col cols="12" class="mt-1 mb-4 text-center">
      <span class="legal-text">
        {{ $t("legal_message_title") }}<br>
        {{ $t("legal_message_sub_title") }}<br>
        {{ $t("legal_message_description") }}
      </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "LegalMessage"
}
</script>

<style lang="stylus" scoped>
  .legal-text
    font font-opensans-min
    color color-gris-oscuro
    font-size 12px

  .legal-text-title
    font font-opensans-min
    color color-purple
    font-size 12px

  .text-purple
    color #5E4FB2
    text-decoration none

  .center-img
    display block
    margin-left auto
    margin-right auto
</style>
